import { render, staticRenderFns } from "./AgentLoanAuthorizationItems.vue?vue&type=template&id=230cfc08"
import script from "./AgentLoanAuthorizationItems.vue?vue&type=script&lang=js"
export * from "./AgentLoanAuthorizationItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports